import React, { useState } from 'react';
import Modal from '../shared/Modal';
import { TextField, SelectField, SegmentedField } from '../shared/FormField';
import { GENETIC_TYPES, PRIMARY_PRODUCTION_TRAITS } from '../data/enums';
import { buildSpeciesOptions, parseApiError } from '../FoundationalTables/SpeciesLivestockRegistry/registryHelpers';

const blank = {
  species_uuid: '',
  breed_code: '',
  breed_name: '',
  genetic_type: '',
  primary_production_trait: '',
};

export default function CreateBreedEcotypeModal({ isOpen, onClose, onCreate, species = [] }) {
  const [form, setForm] = useState(blank);
  const [status, setStatus] = useState('idle');
  const [errMsg, setErrMsg] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const set = (key) => (value) => setForm((current) => ({ ...current, [key]: value }));

  const speciesOptions = buildSpeciesOptions(species);

  const submit = async () => {
    if (submitting) return;

    if (
      !form.species_uuid ||
      !form.breed_code.trim() ||
      !form.breed_name.trim() ||
      !form.genetic_type ||
      !form.primary_production_trait
    ) {
      setErrMsg('Please complete the required fields before saving.');
      setStatus('error');
      return;
    }

    setSubmitting(true);
    setStatus('idle');
    setErrMsg('');

    try {
      await onCreate({
        species_uuid: form.species_uuid,
        breed_code: form.breed_code.trim(),
        breed_name: form.breed_name.trim(),
        genetic_type: form.genetic_type,
        primary_production_trait: form.primary_production_trait,
      });
      setStatus('success');
    } catch (error) {
      setErrMsg(parseApiError(error, 'Unable to create breed record.'));
      setStatus('error');
    } finally {
      setSubmitting(false);
    }
  };

  const handleClose = () => {
    setForm(blank);
    setStatus('idle');
    setErrMsg('');
    setSubmitting(false);
    onClose();
  };

  return (
    <Modal
      title="Create Breed Ecotype Registry"
      isOpen={isOpen}
      onClose={handleClose}
      onSubmit={submit}
      status={status}
      errorMessage={errMsg}
      onContinue={handleClose}
      submitLabel="Create"
      successTitle="Breed Created"
      successMessage="The breed record was saved to the backend."
      isSubmitting={submitting}
    >
      <SelectField
        label="Species"
        required
        value={form.species_uuid}
        onChange={set('species_uuid')}
        options={speciesOptions}
        placeholder="Select Species"
      />
      <TextField
        label="Breed Code"
        required
        value={form.breed_code}
        onChange={set('breed_code')}
        placeholder="e.g. bunaji"
      />
      <TextField
        label="Breed Name"
        required
        value={form.breed_name}
        onChange={set('breed_name')}
        placeholder="e.g. Bunaji (White Fulani)"
      />
      <SegmentedField
        label="Genetic Type"
        required
        value={form.genetic_type}
        onChange={set('genetic_type')}
        options={GENETIC_TYPES}
      />
      <SegmentedField
        label="Primary Production Trait"
        required
        value={form.primary_production_trait}
        onChange={set('primary_production_trait')}
        options={PRIMARY_PRODUCTION_TRAITS}
      />
    </Modal>
  );
}
